import { Route, Redirect } from 'react-router-dom';

function PublicRoute({ children, onlyUnlogged, ...rest }) {
  return (
    <Route
      {...rest}
      key={window.location.pathname}
      render={
        ({ location }) => (
          onlyUnlogged && global.isAuthenticated ? (
            <Redirect
              to={{
                pathname: '/home',
                state: { from: location }
              }}
            />
          ) : (
            children
          ))
      }
    />
  );
}

export default PublicRoute;
